import { useRemoteData } from "@sinch/mfe-helper-react";
import { z } from "zod";
import { getMessageMediaApiUrlMiddleware } from "../../../config/config";
import { useMmToken } from "./useMMToken";

const remainingZod = z.object({
  MT_MMS: z.number().optional(),
  MT_SMS: z.number().optional(),
});
export const accountBalanceResponseZod = z.object({
  currency: z.string().optional(),
  remainingMoney: remainingZod.optional(),
  remainingCredits: remainingZod.optional(),
  relatedAccount: z.string().optional(),
  expiry: z.string().optional(),
});

export type AccountBalanceResponse = z.infer<typeof accountBalanceResponseZod>;

export const useAccountBalance = (shouldFetchAccountBalance: boolean) => {
  const accessToken = useMmToken();
  const accountBalanceRemote = useRemoteData(
    `${getMessageMediaApiUrlMiddleware()}/balance`,
    {
      enabled: !!accessToken && shouldFetchAccountBalance,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      useToken: false,
      parse: (response) => {
        const parsed = accountBalanceResponseZod.safeParse(response);
        if (!parsed.success) {
          const errorMessage = "fetchAccountBalance_failedToParse:";
          console.error(errorMessage, parsed.error);
          throw new Error(errorMessage + parsed.error);
        }
        return parsed.data;
      },
    }
  );

  const accountBalanceState = accountBalanceRemote.getState();

  return accountBalanceState.status === "success"
    ? accountBalanceState.data
    : undefined;
};
